export { ImageUploadToStageEntryPoint } from './imageUploadToStageEntryPoint';
